import * as React from "react";
import { BrManageMenuButton } from "@bloomreach/react-sdk";
import { Header, SiteNav } from "@grandvisionhq/layout";
const CmsHeader = ({
  headerLogo,
  headerLogoMobile,
  headerLogoLink,
  headerMenuItems,
  navMenuItems,
  appointmentMenuItems,
  headerMenuModel,
  navMenuModel,
  appointmentMenuModel,
  pageRoutes,
  availableLocales,
  countrySwitcherOptions,
  myAccountButton,
  isPreview,
  renderCartButton,
  renderWishlistMenuItem,
  onSubmitSearch,
  algoliaHeaderConfig,
  shouldRenderSiteNav = true,
  hasOnlyLogo = false,
  siteName,
  ordersUrl
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, isPreview && headerMenuModel && /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(BrManageMenuButton, { menu: headerMenuModel })), /* @__PURE__ */ React.createElement(
  Header,
  {
    logo: headerLogo,
    logoMobile: headerLogoMobile,
    logoLink: headerLogoLink,
    pageRoutes,
    menuItems: headerMenuItems,
    myAccountButton,
    renderCartButton,
    renderWishlistMenuItem,
    availableLocales,
    algoliaHeaderConfig,
    onSubmit: onSubmitSearch,
    isPreview,
    countrySwitcherOptions,
    shouldRenderSiteNav,
    hasOnlyLogo,
    siteName,
    ordersUrl
  },
  shouldRenderSiteNav && /* @__PURE__ */ React.createElement(React.Fragment, null, isPreview && navMenuModel && /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(BrManageMenuButton, { menu: navMenuModel })), /* @__PURE__ */ React.createElement(
    SiteNav,
    {
      menuItems: navMenuItems,
      appointmentItems: appointmentMenuItems,
      routes: { cart: pageRoutes.cart, stores: pageRoutes.stores },
      countrySwitcherOptions,
      renderCartButton,
      renderWishlistMenuItem,
      ordersUrl
    }
  ), isPreview && appointmentMenuModel && /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(BrManageMenuButton, { menu: appointmentMenuModel })))
));
export {
  CmsHeader,
  CmsHeader as default
};
//# sourceMappingURL=Header.js.map
